import { render } from "./RadiologyReport.vue?vue&type=template&id=4e572e32"
import script from "./RadiologyReport.vue?vue&type=script&lang=js"
export * from "./RadiologyReport.vue?vue&type=script&lang=js"

import "./RadiologyReport.vue?vue&type=style&index=0&id=4e572e32&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__